import React from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import EditEntries from './EditEntries';

const RouteEntries = () => {
  return (
    <Row>
      <Col>
        <EditEntries />
      </Col>
    </Row>
  );
};

export default RouteEntries;
